import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as accountActions from '../../../actions/accountActions';
import { UserAvatar } from '../../common/UserAvatar';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class InactivityReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.closeRefreshModal = this.closeRefreshModal.bind(this);
    this.refreshTokenHandler = this.refreshTokenHandler.bind(this);
  }

  static propTypes = {
    active: PropTypes.bool,
    refreshToken: PropTypes.string,
    user: PropTypes.any,
    configuration: PropTypes.any,
    accountActions: PropTypes.object,
    school: PropTypes.any
  };

  refreshTokenHandler(e) {
    e.preventDefault();
    const { accountActions } = this.props;

    const checkAuthorization = true;
    accountActions.refreshToken(checkAuthorization);
  }

  closeRefreshModal() {
    let { accountActions } = this.props;
    accountActions.setRefreshModalState(false);
    accountActions.logout();
  }

  render() {
    const { active, user, configuration } = this.props;

    return (
      <Modal
        id="inactivity"
        title={
          configuration.allowKeepOnline ? I18n.t('inactivity.closeOrKeepOnline') : I18n.t('inactivity.closeSession')
        }
        active={active}
        onClickOutside={this.closeModal}
        children={
          <>
            <div className="user-content">
              <div className="avatar">
                <UserAvatar user={user} />
              </div>
              <Paragraph type="span" className="list-item text-grey-700">
                {user.name} {user.surname}
              </Paragraph>
            </div>
            <Paragraph className="text-grey-700">
              {I18n.t('inactivity.text')}{' '}
              {configuration.allowKeepOnline
                ? I18n.t('inactivity.textKeepOnline')
                : I18n.t('inactivity.textCloseSession')}
            </Paragraph>
          </>
        }
        footer={
          <>
            <Button onClick={this.closeRefreshModal} label={I18n.t('inactivity.closeSession')}></Button>
            <Button onClick={this.refreshTokenHandler} primary label={I18n.t('inactivity.keepOnline')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    active: state.account.refreshModalIsOpen,
    user: state.account.user,
    refreshToken: state.account.refreshToken,
    configuration: state.account.configuration,
    i18n: state.i18n,
    school: state.school.school
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InactivityReveal);
